import React, {useEffect} from 'react';
import {
  Link,
} from "react-router-dom";

import {connect} from 'react-redux';
// import {Actions as MYACTIONS} from './store/actions/myActions';
// import {Actions as TEAMACTIONS} from './store/actions/teamActions';
// import {Actions as AUTHENTICATIONACTIONS} from './store/actions/authenticationActions';
// import RegistrationForm from '../components/common/RegistrationForm'

function Pricing({

}) {


  return (

    <div id="pricing" className="bg-gray-100">
      <div className="pt-12 sm:pt-16 lg:pt-20">
        <div className="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h2 className="text-3xl leading-9 font-extrabold text-gray-900 sm:text-4xl sm:leading-10 lg:text-5xl lg:leading-none">
              Accountant &amp; Bureau-Friendly Pricing
            </h2>
            <p className="mt-4 text-xl leading-7 text-gray-600">
              Our pricing allows you to grow your clientbase with Buddy. <br/> Cloud Payroll, that frees you up and longer limits your potential income.
            </p>
          </div>
        </div>
      </div>
      <div className="mt-8 bg-white pb-16 sm:mt-12 sm:pb-20 lg:pb-28">
        <div className="relative">
          <div className="absolute inset-0 h-1/2 bg-gray-100"></div>
          <div className="relative max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="max-w-lg mx-auto rounded-lg shadow-lg overflow-hidden lg:max-w-none lg:flex">
              <div className="flex-1 bg-white px-6 py-8 lg:p-12">
                <h3 className="text-2xl leading-8 font-extrabold text-gray-900 sm:text-3xl sm:leading-9">
                  Bureau License
                </h3>
                <p className="mt-6 text-base leading-6 text-gray-500">
                  Buddy Bureau Payroll & HR License allows you to onboard all your clients with a simple package.
                  Provides access to multiple team members, and provides a unique toolset to allow you to provide a higher quality service to your customers.

                </p>
                <p className="mt-6 text-base leading-6 text-gray-500">
                  If you require assistance before bidding for new work or tenders please&nbsp;
                  <a href="https://calendly.com/buddy-intro/buddy-introduction-meeting" target="_blank" className="font-medium text-gray-900">
                    schedule an Appointment
                  </a> to talk to one of our experts.
                </p>
                <div className="mt-8">
                  <div className="flex items-center">
                    <h4 className="flex-shrink-0 pr-4 bg-white text-sm leading-5 tracking-wider font-semibold uppercase text-orange-600">
                      What's included
                    </h4>
                    <div className="flex-1 border-t-2 border-gray-200"></div>
                  </div>
                  <ul className="mt-8 lg:grid lg:grid-cols-2 lg:gap-x-8 lg:gap-y-5">
                    <li className="flex items-start lg:col-span-1">
                      <div className="flex-shrink-0">
                        {/* Heroicon name: check-circle */}
                        <svg className="h-5 w-5 text-green-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                        </svg>
                      </div>
                      <p className="ml-3 text-sm leading-5 text-gray-700">
                        Cloud-Based HR & Payroll Software
                      </p>
                    </li>
                    <li className="mt-5 flex items-start lg:col-span-1 lg:mt-0">
                      <div className="flex-shrink-0">
                        {/* Heroicon name: check-circle */}
                        <svg className="h-5 w-5 text-green-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                        </svg>
                      </div>
                      <p className="ml-3 text-sm leading-5 text-gray-700">
                        Optional Employer Portal
                      </p>
                    </li>
                    <li className="mt-5 flex items-start lg:col-span-1 lg:mt-0">
                      <div className="flex-shrink-0">
                        {/* Heroicon name: check-circle */}
                        <svg className="h-5 w-5 text-green-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                        </svg>
                      </div>
                      <p className="ml-3 text-sm leading-5 text-gray-700">
                        Employee Portal
                      </p>
                    </li>
                    <li className="mt-5 flex items-start lg:col-span-1 lg:mt-0">
                      <div className="flex-shrink-0">
                        {/* Heroicon name: check-circle */}
                        <svg className="h-5 w-5 text-green-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                        </svg>
                      </div>
                      <p className="ml-3 text-sm leading-5 text-gray-700">
                        Chat &amp; Email Support
                      </p>
                    </li>
                    <li className="mt-5 flex items-start lg:col-span-1 lg:mt-0">
                      <div className="flex-shrink-0">
                        {/* Heroicon name: check-circle */}
                        <svg className="h-5 w-5 text-green-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                        </svg>
                      </div>
                      <p className="ml-3 text-sm leading-5 text-gray-700">
                        Unlimited Clients
                      </p>
                    </li>
                    <li className="mt-5 flex items-start lg:col-span-1 lg:mt-0">
                      <div className="flex-shrink-0">
                        {/* Heroicon name: check-circle */}
                        <svg className="h-5 w-5 text-green-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                        </svg>
                      </div>
                      <p className="ml-3 text-sm leading-5 text-gray-700">
                        Unlimited Staff Members
                      </p>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="py-8 px-6 text-center bg-gray-50 lg:flex-shrink-0 lg:flex lg:flex-col lg:justify-center lg:p-12">
                <div className="mt-6">
                  <div className="rounded-md shadow">
                    <a href="https://calendly.com/buddy-intro/buddy-introduction-meeting" target="_blank" className="flex items-center justify-center px-5 py-3 border border-transparent text-base leading-6 font-medium rounded-md text-white bg-gray-900 hover:bg-gray-800 focus:outline-none focus:shadow-outline transition duration-150 ease-in-out">
                      Schedule an Appointment
                    </a>
                  </div>
                </div>
                <p className="mt-4 text-sm leading-5">
                  to learn more about our Bureau License
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


    
    
  );
}

const mapStateToProps = (state) => {

  // const {
  //   myAgreements,
  // } = state.my


  return {
    // showSidebar: state.sidebar.show,
    // loggedIn: state.my.profile ? true : false,
  }
}

const mapDispatchToProps = dispatch => ({
  // myGetAgreements: () => dispatch(MYACTIONS.myGetAgreements()),
  // getProfile: () => dispatch(MYACTIONS.getProfile()),
  // isLoggedIn: () => dispatch(AUTHENTICATIONACTIONS.isLoggedIn()),
  // getDepartments: () => dispatch(TEAMACTIONS.getDepartments()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Pricing) 
